module.exports = __webpack_public_path__ + "static/media/bv-logo-sm.919d3c0c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bv-logo-sm.svg
// module id = 260
// module chunks = 20